import { render, staticRenderFns } from "./EventRoomContentElementChatThreadItem.vue?vue&type=template&id=b584b864&"
import script from "./EventRoomContentElementChatThreadItem.vue?vue&type=script&lang=js&"
export * from "./EventRoomContentElementChatThreadItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
